// @flow
import type { ComponentType, Ref } from "react";

/**
 */
export const getDisplayName = (
  WrappedComponent: ComponentType<any>,
  defaultName: string = "Component",
  contextId?: string,
): string => {
  const componentName =
    WrappedComponent.displayName || WrappedComponent.name || defaultName;

  if (contextId) {
    return `${componentName}[${contextId}]`;
  }

  return componentName;
};

/**
 */
export const mergeRefs =
  <T: any>(refs: Array<Ref<T>>): Ref<T> =>
  (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null && typeof ref === "object") {
        ref.current = value;
      }
    });
  };
